import { ErrorsRelationBuilder } from "./ErrorsRelationBuilder.js";
import { ReadBuilder } from "./ReadBuilder.js";
import { ValidationRelationBuilder } from "./ValidationRelationBuilder.js";
import { WriteDataBuilder } from "./WriteDataBuilder.js";
import { ObjectBuilder } from "../graphQlBuilder/ObjectBuilder.js";
class WriteBuilder {
  constructor(objectBuilder = new ObjectBuilder()) {
    this.objectBuilder = objectBuilder;
  }
  static instantiate(objectBuilder = new ObjectBuilder()) {
    return new WriteBuilder(objectBuilder);
  }
  static instantiateFromFactory(builder) {
    if (typeof builder === "function") {
      return builder(WriteBuilder.instantiate());
    }
    return builder;
  }
  data(data) {
    const resolvedData = WriteDataBuilder.resolveData(data);
    return WriteBuilder.instantiate(
      resolvedData === void 0 ? this.objectBuilder : this.objectBuilder.argument("data", resolvedData)
    );
  }
  by(by) {
    return WriteBuilder.instantiate(this.objectBuilder.argument("by", by));
  }
  ok() {
    return WriteBuilder.instantiate(this.objectBuilder.field("ok"));
  }
  errorMessage() {
    return WriteBuilder.instantiate(this.objectBuilder.field("errorMessage"));
  }
  validation() {
    return WriteBuilder.instantiate(
      ValidationRelationBuilder.validationRelation(this.objectBuilder)
    );
  }
  errors() {
    return WriteBuilder.instantiate(
      ErrorsRelationBuilder.errorsRelation(this.objectBuilder)
    );
  }
  node(builder) {
    const readBuilder = ReadBuilder.instantiateFromFactory(builder);
    return WriteBuilder.instantiate(
      this.objectBuilder.object("node", readBuilder.objectBuilder)
    );
  }
}
export {
  WriteBuilder
};
//# sourceMappingURL=WriteBuilder.js.map
